import { ISingleUser, ITableRes, IUserRes } from 'types'

import { baseApi } from './baseApi'

export const userAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    GET_user: builder.query<IUserRes, void>({
      query: () => ({
        url: '/profile/',
      }),
      providesTags: ['user'],
    }),
    GET_avatarParts: builder.query<IUserRes, any>({
      query: (params) => ({
        url: '/avatar-parts/',
        params,
      }),
      providesTags: ['avatar'],
    }),
    GET_userContacts: builder.query<ITableRes<ISingleUser>, any>({
      query: (params) => ({
        url: `/user-contacts/`,
        params
      }),
      providesTags: ['user-contacts'],
    }),
  }),
})

export const { useGET_userQuery, useGET_avatarPartsQuery, useGET_userContactsQuery } = userAPI
